// src/locales/document-vi.ts
export default {
  documents: {
    title: "Thư viện tài liệu",
    searchPlaceholder: "Tìm kiếm tài liệu...",
    uploadDocument: "Tải lên tài liệu",
    documentDetails: "Chi tiết tài liệu",
    editDocument: "Chỉnh sửa tài liệu",
    reviews: "Đánh giá",
    recentDocuments: "Tài liệu gần đây",
    library: "Thư viện tài liệu",
    documentList: "Danh sách tài liệu",
    documentReader: "Đọc tài liệu",
    noDocuments: "Không tìm thấy tài liệu nào",
    createFirstDocument: "Tạo tài liệu đầu tiên của bạn",
    confirmDeleteMessage: "Bạn có chắc chắn muốn xóa tài liệu này không?",
    tagline: "Khám phá, đọc và chia sẻ tài liệu",
    filter: "Lọc tài liệu",
    sort: "Sắp xếp",
    explore: "Khám phá thư viện",
    loading: "Đang tải tài liệu...",
    notFound: "Không tìm thấy tài liệu",
    
    categories: {
      all: "Tất cả tài liệu",
      business: "Kinh doanh & Tài chính",
      tech: "Công nghệ",
      education: "Giáo dục",
      law: "Pháp luật",
      art: "Văn học & Nghệ thuật"
    },
    
    filters: {
      all: "Tất cả",
      free: "Miễn phí",
      paid: "Trả phí",
      rating: "Đánh giá tối thiểu",
      category: "Danh mục",
      type: "Loại tài liệu"
    },
    
    status: {
      published: "Đã xuất bản",
      pendingReview: "Đang chờ duyệt",
      draft: "Bản nháp",
      rejected: "Bị từ chối",
      all: "Tất cả trạng thái"
    },
    
    detail: {
      author: "Tác giả",
      publishDate: "Ngày đăng",
      views: "lượt xem",
      rating: "đánh giá",
      description: "Mô tả",
      details: "Thông tin chi tiết",
      format: "Định dạng",
      pageCount: "Số trang",
      fileSize: "Kích thước",
      language: "Ngôn ngữ",
      uploadDate: "Đăng tải",
      lastUpdate: "Cập nhật",
      preview: "Xem trước",
      reviewsAndRatings: "Đánh giá và nhận xét",
      writeReview: "Viết đánh giá của bạn",
      yourReview: "Nhận xét của bạn về tài liệu này...",
      submitReview: "Gửi đánh giá",
      authorInfo: "Thông tin tác giả",
      viewProfile: "Xem hồ sơ",
      relatedDocuments: "Tài liệu liên quan",
      price: "Giá",
      free: "Miễn phí",
      buyNow: "Mua ngay",
      readPreview: "Đọc thử",
      favorite: "Yêu thích",
      share: "Chia sẻ"
    },
    
    reader: {
      backToDetails: "Quay lại",
      download: "Tải xuống",
      print: "In",
      share: "Chia sẻ",
      save: "Lưu",
      tableOfContents: "Mục lục",
      prevPage: "Trang trước",
      nextPage: "Trang sau",
      page: "Trang",
      of: "/"
    },
    
    myDocuments: {
      title: "Tài liệu của tôi",
      subtitle: "Quản lý tài liệu đã tải lên và đã mua",
      uploadNew: "Tải lên tài liệu mới",
      tabs: {
        uploaded: "Đã tải lên",
        purchased: "Đã mua"
      },
      search: {
        uploaded: "Tìm kiếm tài liệu...",
        purchased: "Tìm kiếm tài liệu đã mua..."
      },
      table: {
        document: "Tài liệu",
        status: "Trạng thái",
        price: "Giá",
        views: "Lượt xem",
        downloads: "Lượt mua",
        createdAt: "Ngày tạo",
        actions: "Thao tác"
      },
      fileInfo: {
        type: "Định dạng",
        size: "Kích thước",
        pages: "trang"
      },
      actions: {
        view: "Xem",
        edit: "Sửa",
        delete: "Xóa",
        readNow: "Đọc ngay",
        download: "Tải xuống"
      },
      purchaseInfo: {
        purchaseDate: "Ngày mua",
        expiryDate: "Hết hạn"
      },
      emptyStates: {
        uploadedTitle: "Chưa có tài liệu nào",
        uploadedDesc: "Bắt đầu chia sẻ kiến thức của bạn bằng cách tải lên tài liệu đầu tiên",
        uploadButton: "Tải lên tài liệu mới",
        purchasedTitle: "Chưa mua tài liệu nào",
        purchasedDesc: "Khám phá thư viện tài liệu của chúng tôi để tìm tài liệu phù hợp với bạn",
        exploreButton: "Khám phá thư viện"
      },
      pagination: "Hiển thị {{from}}-{{to}} trong tổng số {{total}} kết quả"
    },
    
    upload: {
      title: "Tải lên tài liệu mới",
      subtitle: "Chia sẻ kiến thức và kiếm thu nhập từ tài liệu của bạn",
      form: {
        documentTitle: "Tiêu đề tài liệu",
        titlePlaceholder: "Nhập tiêu đề tài liệu",
        titleHelp: "Tiêu đề rõ ràng sẽ giúp tài liệu của bạn dễ tìm kiếm hơn",
        description: "Mô tả",
        descriptionPlaceholder: "Mô tả chi tiết về nội dung tài liệu...",
        descriptionHelp: "Mô tả chi tiết giúp người đọc hiểu được nội dung và quyết định mua tài liệu của bạn",
        category: "Danh mục",
        selectCategory: "Chọn danh mục",
        language: "Ngôn ngữ",
        tags: "Từ khóa",
        tagsPlaceholder: "Nhập các từ khóa, cách nhau bởi dấu phẩy",
        tagsHelp: "Ví dụ: marketing, chiến lược, phân tích thị trường, Việt Nam",
        pricingSection: "Thiết lập giá và bảo vệ",
        pricingModel: "Hình thức",
        free: "Miễn phí",
        paid: "Trả phí",
        price: "Giá (VNĐ)",
        pricePlaceholder: "Nhập giá tài liệu",
        feeInfo: "Phí nền tảng: 20% (bạn nhận được: {{amount}} VNĐ)",
        upload: {
          title: "Tải lên tài liệu",
          dragDrop: "Kéo thả tệp hoặc nhấp để chọn",
          formats: "Định dạng hỗ trợ: PDF, DOCX, PPTX, XLSX",
          maxSize: "Tối đa: 100MB",
          selectFile: "Chọn tệp",
          selected: "Đã chọn: {{name}} ({{size}} MB)"
        },
        cover: {
          title: "Ảnh bìa",
          upload: "Tải lên ảnh bìa",
          sizeTip: "Kích thước đề xuất: 1200 x 1600 pixel (tỷ lệ 3:4)"
        },
        publish: {
          title: "Xuất bản",
          publishNow: "Xuất bản ngay sau khi được duyệt",
          saveDraft: "Lưu nháp",
          reviewNote: "Tài liệu của bạn sẽ được kiểm duyệt trước khi xuất bản (thường trong vòng 24 giờ)",
          termsCheck: "Tôi đảm bảo tài liệu này không vi phạm bản quyền và đồng ý với Điều khoản dịch vụ",
          submitButton: "Hoàn tất tải lên",
          cancelButton: "Hủy",
          processing: "Đang xử lý..."
        }
      }
    }
  }
};